import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm text-muted-foreground">Loading…</div>
    </div>
  )
}

/**
 * Gate for the authenticated app. While MSAL is mid-flight (startup / handling the
 * redirect / logging in) we render a loader instead of bouncing to /login, which
 * would otherwise cause a redirect loop on return from B2C.
 */
export default function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return <FullScreenLoader />
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }
  return <Outlet />
}
